import {
	DynamicContextProvider,
	DynamicEmbeddedWidget,
} from "@dynamic-labs/sdk-react-core"
import Toast from "./components/Toast/Toast"
import { useWeb3Auth } from "./hooks"
import { en, es, pt } from "./translation"
import { Logo, LocaleSwitcher } from "./components"

export default function App() {
	const { error, setError, dynamicSettings } = useWeb3Auth()

	const dynamicLocale = {
		en: en,
		es: es,
		pt: pt,
	}

	return (
		<div data-testid="app">
			<DynamicContextProvider
				settings={dynamicSettings}
				locale={dynamicLocale}
			>
				<div className="header">
					<Logo />
					<LocaleSwitcher />
				</div>
				<div className="widget-container">
					<DynamicEmbeddedWidget background="default" />
				</div>
				{error && (
					<Toast text={error} isVisible={error !== undefined} onClose={() => setError(undefined)} />
				)}
			</DynamicContextProvider>
		</div>
	)
}
